const doc = [({"da":({"js":({"admin":({"activities":({"live":({"agenda":({"item_types":({"election":({"index":({"ballot":"Stemmeseddel:"})})})})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;